// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {mantineCssStyleRecordSchema} from "./primitives.zod";

export const mantineTitlePropsSchema = z.object({
	style: mantineCssStyleRecordSchema.optional(),
});
